// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Інформаційні моделі» (Information Models, ключ `inf`, група `meta`). */
export const informationModelsManifest: IModuleManifest = {
  key: 'inf',
  group: 'meta',
  slug: 'information-models',
  prefix: 'INF',
  name: { en: 'Information Models', uk: 'Інформаційні моделі' },
  entities: [
    { key: 'inf', slug: 'inf', name: { en: 'Information Models', uk: 'Інформаційні моделі' }, main: true },
    { key: 'entity_field', slug: 'entity-field', name: { en: 'Entity Fields', uk: 'Поля' }, main: false },
    { key: 'entity_dictionary', slug: 'entity-dictionary', name: { en: 'Entity Dictionaries', uk: 'Довідники' }, main: false },
    { key: 'entity_relation_type', slug: 'entity-relation-type', name: { en: 'Entity Relation Types', uk: 'Типи зв’язків' }, main: false },
  ],
  loadState: () => import('./state/informationModelsSlice').then((m) => m.informationModelsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
